var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState, useMemo } from 'react';
import { Translate, I18NApi } from "../../../../../I18N";
import { Button, Modal } from "../../../../Components/UI";
import { defaultSearch, MultiselectList } from "../../../../Components/Forms";

import { RequestParams } from "../../../../../utils/RequestParams";
import { useApiCaller } from "../../../../CustomHooks/useApiCaller";






const InstallLanguagesModal = ({ setShowModal, languages }) => {
  const [selected, setSelected] = useState([]);
  const { requestAction } = useApiCaller();

  const items = useMemo(
    () =>
    languages.map((l) => ({
      label: `${l.translationAvailable ? ' * ' : ''}${l.label} (${l.key})`,
      value: l.key,
      searchLabel: l.label
    })),
    [languages]
  );

  const [options, setOptions] = useState(items);

  const install = async () => {
    setShowModal(false);
    await requestAction(
      I18NApi.addLanguage,
      new RequestParams(languages.filter((l) => selected.includes(l.key))), /*#__PURE__*/
      _jsx(Translate, { translationKey: "Language Install Start Message" }, void 0, "Language installation process initiated. It may take several minutes to complete depending on the size of the collection. Please wait until the installation process is finished."


      )
    );
  };

  return (/*#__PURE__*/
    _jsx(Modal, { size: "lg" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Install Language(s)")
    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
    ), /*#__PURE__*/
    _jsx(Modal.Body, { className: "pt-0" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "block px-2 pt-4 text-justify text-gray-700" }, void 0, "This action may take some time while we add the extra language to the entire collection."

    ), /*#__PURE__*/
    _jsx("div", { className: "h-96 pt-2" }, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      items: options,
      onChange: (s) => setSelected(s),
      onSearch: (s) => setOptions(() => defaultSearch(s, items)) }
    )
    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "w-full pt-0 pb-3 text-sm font-normal text-gray-500 dark:text-gray-400" }, void 0, "* ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Available default translation")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setShowModal(false), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      onClick: async () => {
        await install();
      },
      className: "grow",
      disabled: !selected.length }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Install"), " ", selected.length ? `(${selected.length})` : ''
    )
    )
    )
    )
    ));

};

export { InstallLanguagesModal };